import { useState } from 'react';

import { RemoteLineCreditCard } from 'components/RemoteLineCreditCard';
import { RemoteLineStatusOnPayment } from 'components/RemoteLineStatusOnPayment';
import { RemoteLineDetails } from 'components/RemoteLineDetails';
import { useLine } from 'hooks/use-line';
import { useAuth } from 'hooks/use-auth';
import * as S from './styles';
import { Event } from 'utils/helpers';

type StatusProps = 'success' | 'error' | '';

export const RemoteLine = () => {
  const { user } = useAuth();
  const { unit, settings, handleSetUnit, setQuantity } = useLine();
  const [payment, setPayment] = useState(false);
  const [status, setStatus] = useState<StatusProps>('');

  return (
    <S.Modal
      isOpen={!!unit && !!settings && !!user}
      width="15%"
      onRequestClose={() => {
        handleSetUnit(null);
        setQuantity(null);
      }}
    >
      {!!status && (
        <RemoteLineStatusOnPayment
          status={status}
          onPressBack={() => {
            const payment = settings?.pricing ? true : false;

            setPayment(payment);
            setStatus('');
          }}
        />
      )}

      {!payment && !status && (
        <RemoteLineDetails
          onPressContinue={() => {
            Event.push('getin_line_step1_continue_click', {
              user_id: user?.id,
            });
            setPayment(true);
          }}
          onSuccess={() => {
            setStatus('success');
            Event.push('getin_line_created', {
              unit_id: unit?.id,
              user_id: user?.id,
            });
          }}
          onError={() => setStatus('error')}
        />
      )}

      {payment && !status && (
        <RemoteLineCreditCard
          onPressBack={() => {
            Event.push('getin_line_step2_back_click', {
              user_id: user?.id,
            });
            setPayment(false);
          }}
          onSuccess={() => {
            setStatus('success');
            Event.push('getin_line_created', {
              unit_id: unit?.id,
              user_id: user?.id,
            });
          }}
          onError={() => setStatus('error')}
        />
      )}
    </S.Modal>
  );
};
